import React from "react";

/**
 * Map Legend Component showing status color codes
 */
const MapLegend = ({ t, getStatusColor, getStatusText }) => {
  return (
    <div className="px-6 py-3 bg-gray-50 border-b border-gray-200">
      <div className="flex items-center space-x-6">
        <span className="text-sm font-medium text-gray-700">
          {t("scheduleMap.legend")}:
        </span>
        {["SCHEDULED", "IN_DELIVERY", "DELIVERED", "MISSED"].map((status) => (
          <div key={status} className="flex items-center space-x-2">
            <div
              className="w-3 h-3 rounded-full border border-white"
              style={{ backgroundColor: getStatusColor(status) }}
            />
            <span className="text-xs text-gray-600">
              {getStatusText(status)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapLegend;
